<template>
  <div class="search-box">
    <el-form ref="searchFormRef" :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item label="姓名" prop="employeeName">
        <el-input v-model="formInline.employeeName" clearable placeholder="请输入" />
      </el-form-item>
      <el-form-item label="手机号" prop="employeePhone">
        <el-input v-model="formInline.employeePhone" clearable placeholder="请输入" />
      </el-form-item>
      <el-form-item label="所属公司" prop="companyName">
        <el-input v-model="formInline.companyName" clearable placeholder="请输入" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">查询</el-button>
        <el-button @click="onReset(searchFormRef)">重置</el-button>
      </el-form-item>
    </el-form>
  </div>
  <div class="table-box">
    <div class="table-btns">
      <el-button type="primary" :icon="Download" @click="downloadTemp">下载模板</el-button>
      <el-upload style="margin-left: 14px;" :auto-upload="false" v-model:file-list="fileList" class="upload-demo"
        :show-file-list="false" accept=".xlsx" :on-preview="handlePreview" :headers="{
          authorization: `Bearer ${$cookies.get('token')}`,
        }" :on-change="onChange" :limit="1">
        <el-button type="primary" :icon="Upload">导入团检用户</el-button>
      </el-upload>
      <el-button style="margin-left: 14px;" type="danger" :icon="Delete" @click="batchDelFn">批量删除</el-button>
    </div>
    <el-table :data="tableData" border style="width: 100%" @selection-change="handleSelectionChange">
      <el-table-column type="selection" align="center" width="55" />
      <el-table-column prop="employeeName" label="姓名" align="center" />
      <el-table-column prop="employeePhone" label="手机号" align="center" />
      <el-table-column prop="employeeIdNo" label="身份证号" align="center" />
      <el-table-column prop="expirationDate" label="截止日期" align="center" />
      <el-table-column prop="principal" label="负责人姓名" align="center" />
      <el-table-column prop="principalPhone" label="负责人电话" align="center" />
      <el-table-column prop="companyName" label="所属公司" align="center" />
      <el-table-column prop="richPackageNo" label="瑞慈体检（套餐号）" align="center" />
      <el-table-column prop="mnPackageNo" label="美年大健康（套餐号）" align="center" />
      <el-table-column prop="akPackageNo" label="爱康国宾（套餐号）" align="center" />
      <el-table-column prop="cmPackageNo" label="慈铭（套餐号）" align="center" />
      <el-table-column prop="createTime" label="创建时间" align="center" />
    </el-table>
    <el-pagination class="pagination" v-model:current-page="currentPage" v-model:page-size="pageSize"
      :page-sizes="[10, 50, 100, 200]" :small="small" :background="background"
      layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="handleSizeChange"
      @current-change="handleCurrentChange" />
  </div>
</template>
<script setup>
import { reactive, ref, onMounted, nextTick } from "vue";
import { ElMessageBox, ElMessage } from "element-plus";
import { Download, Upload, Delete } from "@element-plus/icons-vue";

import service from "@/http/request.js";

const fileList = ref([])

const tableData = ref([]);

const formInline = reactive({
  employeeName: null,
  employeePhone: null,
  companyName: null,
});
const searchFormRef = ref();
const onSubmit = () => {
  _userList();
};
const onReset = (formEl) => {
  formEl.resetFields();
  pageSize.value = 10;
  currentPage.value = 1;
  _userList();
};
const currentPage = ref(1);
const pageSize = ref(10);
const total = ref(0);
const handleSizeChange = (val) => {
  pageSize.value = val;
  _userList();
};
const handleCurrentChange = (val) => {
  currentPage.value = val;
  _userList();
};
const _userList = () => {
  service.post('/health/web/groupUser/page', {
    pageSize: pageSize.value || null,
    pageNo: currentPage.value || null,
    ...formInline
  })
    .then(data => {
      console.log(data)
      if (data.data.code == 200) {
        tableData.value = data.data.data.records
        total.value = data.data.data.total
      }
    })
    .catch(err => {
      ElMessage({
        message: err.message,
        type: "error",
      });
    })
};

let selectionTable = ref([]);
const handleSelectionChange = (val) => {
  selectionTable.value = val;
};
const batchDelFn = () => {
  console.log(selectionTable.value.length);

  if (selectionTable.value.length < 1) {
    ElMessage({
      message: "请选择需要删除的数据",
      type: "warning",
    });
    return;
  }
  ElMessageBox.confirm("请确认是否删除？", "提示", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning",
    closeOnClickModal: false,
  }).then(() => {
    console.log(selectionTable.value);
    let ids = [];
    selectionTable.value.forEach((item) => {
      ids.push(item.id);
    });
    service({
      method: 'get',
      url: '/health/web/groupUser/delete',
      params: {
        ids: ids.join(",")
      },
    })
      .then(data => {
        console.log(data)
        ElMessage({
          message: "删除成功",
          type: "success",
        });
        _userList();
      })
      .catch(err => {
        ElMessage({
          message: err.message,
          type: "error",
        });
      })
  })
};
// 导出
const downloadTemp = () => {
  service({
    method: 'get',
    url: '/health/web/groupUser/downloadTemplate',
    data: {},
    responseType: 'blob'
  })
    .then(data => {
      console.log(data)
      // 处理返回的 blob 数据，进行下载等操作
      const blob = new Blob([data.data], { type: 'application/vnd.ms-excel' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = "团检模板.xlsx";
      link.click();
      URL.revokeObjectURL(url);
    })
    .catch(err => {
      ElMessage({
        message: err.message,
        type: "error",
      });
    })
};

const onChange = (file) => {
  console.log(file);
  const formData = new FormData();
  formData.append('file', file.raw);
  service({
    method: 'post',
    url: '/health/web/groupUser/import',
    data: formData,
    responseType: 'blob',
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
    .then(data => {
      console.log(data)
      _userList();
      // 处理返回的 blob 数据，进行下载等操作
      const blob = new Blob([data.data], { type: 'application/vnd.ms-excel' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = "团检用户核验.xlsx";
      link.click();
      URL.revokeObjectURL(url);
    })
    .catch(err => {
      ElMessage({
        message: err.message,
        type: "error",
      });
    })
}

onMounted(() => {
  _userList();
});

</script>
<style scoped lang="scss">
.flex {
  display: flex;
}

.items-center {
  align-items: center;
}

.justify-center {
  justify-content: center;
}

.success {
  color: #02bc6c;
}

.red {
  color: #da0f0f;
}

.blue {
  color: #0051b7;
}
</style>
